module.exports = __webpack_public_path__ + "static/Aksara CMS-adfbae4a942c8c278ee22fa699da5c0a.svg";